import type { CSSProperties } from 'react';
import type { ImageBlock as ImageBlockDoc } from '../types';

/**
 * Obrázek. `src` má být vlastní médium (relativní cesta) nebo absolutní URL
 * na vlastní origin — validaci drží server; tady jen bezpečně vykreslíme.
 */
export function ImageBlock({ block }: { block: ImageBlockDoc }) {
  const wrap: CSSProperties = {
    textAlign: block.align,
  };
  const img: CSSProperties = {
    width: `${Math.max(10, Math.min(100, block.widthPercent))}%`,
    maxWidth: '100%',
  };
  return (
    <div className="layer-image" style={wrap}>
      <img src={block.src} alt={block.alt} style={img} loading="lazy" decoding="async" />
    </div>
  );
}
